import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Listings = lazy(() => import('../../container/listings-management/listings'));
const AddListing = lazy(() => import('../../container/listings-management/listings/Add'));
const EditListing = lazy(() => import('../../container/listings-management/listings/Edit'));
const ViewListing = lazy(() => import('../../container/listings-management/listings/View'));

const ItemCategories = lazy(() => import('../../container/listings-management/item-categories'));
const ItemConditions = lazy(() => import('../../container/listings-management/item-conditions'));
const ServiceCategories = lazy(() => import('../../container/listings-management/service-categories'));
const Expertise = lazy(() => import('../../container/listings-management/expertise'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/listings`} component={Listings} />
      <Route exact path={`${path}/listings/add`} component={AddListing} />
      <Route exact path={`${path}/listings/edit/:slug`} component={EditListing} />
      <Route exact path={`${path}/listings/view/:slug`} component={ViewListing} />

      <Route exact path={`${path}/item-categories`} component={ItemCategories} />
      <Route exact path={`${path}/item-conditions`} component={ItemConditions} />
      <Route exact path={`${path}/service-categories`} component={ServiceCategories} />
      <Route exact path={`${path}/expertise`} component={Expertise} />
    </Switch>
  );
}

export default PagesRoute;
